<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-13 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <!-- Kontaktinfo -->
                        <h3 class="archive-title">Kontakt</h3>
                        <p>ÖBAK – Österreichische Akademie für ärztliche und pflegerische Begutachtung</p>
                        <p>c/o Pensionsversicherungsanstalt</p>
                        <p>Friedrich-Hillegeist-Straße 1<br>1021 Wien<br>&nbsp;<br></p>
                        <!-- Formular -->
                        <div class="wpcf7">
                            <form [formGroup]="kontaktForm" (ngSubmit)="senden()">
                                <div class="contact-form clearfix">
                                    <!-- Name -->
                                    <div class="full-row clearfix">
                                        <p>
                                            <span class="contact-label"><br>
                                                 <label>Name</label><br>
                                                 <span class="small-text">
                                                      <br>Ihr vollständiger Name<br>
                                                 </span><br>
                                            </span><br>
                                            <span class="wpcf7-form-control-wrap">
                                                 <input type="text" formControlName="name">
                                                <div class="invalid-input" *ngIf="kontaktForm.controls.name.invalid && submitted">
                                                    Bitte füllen Sie diese Pflichtfeld aus!
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <!-- E-Mail -->
                                    <div class="full-row clearfix">
                                        <p>
                                            <span class="contact-label"><br>
                                               <label>E-Mail</label><br>
                                                <span class="small-text"><br>
                                                    Ihre E-Mail-Adresse<br>
                                                </span><br>
                                            </span><br>
                                            <span class="wpcf7-form-control-wrap">
                                                <input type="email" formControlName="email">
                                                <div class="invalid-input" *ngIf="kontaktForm.controls.email.invalid && submitted">
                                                    Die E-Mail-Adresse scheint ungültig zu sein.
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <!-- Betreff -->
                                    <div class="full-row clearfix">
                                        <p>
                                            <span class="contact-label"><br>
                                                <label>Betreff</label><br>
                                                <span class="small-text"><br>
                                                  Betreff Ihres Anliegens<br>
                                                </span><br>
                                            </span><br>
                                            <span class="wpcf7-form-control-wrap">
                                                <input type="text" formControlName="betreff">
                                                <div class="invalid-input" *ngIf="kontaktForm.controls.betreff.invalid && submitted">
                                                    Bitte füllen Sie diese Pflichtfeld aus!
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <!-- Nachricht -->
                                    <div class="full-row clearfix">
                                        <p>
                                            <span class="contact-label"><br>
                                                <label>Nachricht</label><br>
                                                <span class="small-text"><br>
                                                    Beschreiben Sie Ihr Anliegen<br>
                                                </span><br>
                                            </span><br>
                                            <span class="wpcf7-form-control-wrap">
                                                <textarea cols="40" rows="10" formControlName="nachricht"></textarea>
                                                <div class="invalid-input" *ngIf="kontaktForm.controls.nachricht.invalid && submitted">
                                                    Bitte füllen Sie diese Pflichtfeld aus!
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                    <!-- Submit -->
                                    <div class="full-row">
                                        <p>
                                            <input class="wpcf7-submit mainBtn" type="submit" value="Senden">
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div> <!-- /.widget-inner -->
                </div> <!-- /.widget-main -->
            </div>
        </div> <!-- /.col-md-12 -->
    </div> <!-- /.row -->
</div>
